module.exports = __webpack_public_path__ + "img/Insta-Bsp-02.c8136ba1.jpg";